// extracted by mini-css-extract-plugin
export default {"badge":"XBadge_badge__7jeKg"};